import { Directive, Output, EventEmitter, ElementRef, AfterViewInit, OnDestroy, Input } from '@angular/core';

export type ObserverParams = IntersectionObserverInit & { once: boolean };

@Directive({
  selector: '[opacViewportObserver]',
})
export class ViewportObserverDirective implements AfterViewInit, OnDestroy {
  private static readonly DEFAULT_STATE: ObserverParams = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
    once: false,
  };

  @Output()
  visible: EventEmitter<void> = new EventEmitter();

  @Input('opacViewportObserver')
  set params(ovParams: ObserverParams) {
    this.internalParams = { ...ViewportObserverDirective.DEFAULT_STATE, ...ovParams };
  }

  private internalParams: ObserverParams;
  private observer?: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target === this.el.nativeElement) {
          this.visible.emit();

          if (this.internalParams.once) {
            this.observer.unobserve(this.el.nativeElement);
          }
        }
      });
    }, this.internalParams);

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.unobserve(this.el.nativeElement);
      this.observer.disconnect();
    }
  }
}
